import { render, staticRenderFns } from "./EmtaVehicleSelection.vue?vue&type=template&id=2edebc05&scoped=true"
import script from "./EmtaVehicleSelection.vue?vue&type=script&lang=js"
export * from "./EmtaVehicleSelection.vue?vue&type=script&lang=js"
import style0 from "./EmtaVehicleSelection.vue?vue&type=style&index=0&id=2edebc05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edebc05",
  null
  
)

export default component.exports